import type { Filter } from "@/types/script";
import { create } from "zustand";

type ValidOrderBy = "asc" | "desc";

interface useFilterStore {
  filters: Filter;
  setFilters: (filters: Partial<useFilterStore["filters"]>) => void;
}

export const useFilter = create<useFilterStore>((set, get) => ({
  filters: {
    payment: undefined,
    mobile: undefined,
    key_system: undefined,
    sortBy: "Upload Date",
    orderBy: "desc" as ValidOrderBy,
  },
  setFilters: (filters) => {
    const orderBy =
      filters.orderBy === "asc" || filters.orderBy === "desc"
        ? filters.orderBy
        : get().filters.orderBy;

    const key_system =
      filters.payment === "Paid"
        ? undefined
        : filters.key_system !== undefined
          ? filters.key_system
          : get().filters.key_system;

    set({
      filters: {
        ...get().filters,
        ...filters,
        key_system,
        orderBy,
      },
    });
  },
}));
